import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { MODULE_COLORS } from '@cubemeet/core/theme';

interface Props {
  value: string;
  onChange: (v: string) => void;
  options: { id: string; labelKey: string; descKey?: string }[];
  t: (key: string) => string;
}

const PaymentModePicker: React.FC<Props> = ({ value, onChange, options, t }) => {
  return (
    <View style={{ gap: 12 }}>
      {options.map((o) => (
        <TouchableOpacity key={o.id} style={[styles.row, value === o.id && styles.rowActive]} onPress={() => onChange(o.id)}>
          <View style={value === o.id ? styles.radioActive : styles.radio} />
          <View style={{ flex: 1 }}>
            <Text style={[styles.label, value === o.id && styles.labelActive]}>{t(o.labelKey)}</Text>
            {o.descKey && (
              <Text style={styles.desc}>{t(o.descKey)}</Text>
            )}
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', padding: 12, borderRadius: 12, borderWidth: 1, borderColor: '#E5E7EB' },
  rowActive: { borderColor: MODULE_COLORS.travel, backgroundColor: '#FFF7ED' },
  radio: { width: 18, height: 18, borderRadius: 9, borderWidth: 2, borderColor: '#E5E7EB', marginRight: 12 },
  radioActive: { width: 18, height: 18, borderRadius: 9, borderWidth: 2, borderColor: MODULE_COLORS.travel, backgroundColor: MODULE_COLORS.travel, marginRight: 12 },
  label: { color: '#374151', fontSize: 14 },
  labelActive: { color: MODULE_COLORS.travel, fontWeight: '700' },
  desc: { color: '#9CA3AF', fontSize: 13, marginTop: 4 },
});

export default PaymentModePicker;
